import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';

// One player shared by the selected-voice card and the library. Creator samples
// are never represented as output from the agent's conversational model.
export const useVoiceSample = () => {
  const audioRef = useRef(null);
  const generation = useRef(0);
  const [playingId, setPlayingId] = useState(null);
  const stop = useCallback(() => {
    generation.current += 1;
    if (audioRef.current) {
      audioRef.current.onended = null;
      audioRef.current.onerror = null;
      audioRef.current.pause();
      audioRef.current.removeAttribute('src');
      audioRef.current.load();
      audioRef.current = null;
    }
    setPlayingId(null);
  }, []);
  const play = useCallback(async (voice) => {
    const wasPlaying = audioRef.current?.dataset.voiceId === voice.voice_id;
    stop();
    if (wasPlaying || !voice.preview_url) return;
    const request = generation.current;
    const audio = new Audio(voice.preview_url);
    audio.dataset.voiceId = voice.voice_id;
    audioRef.current = audio;
    const fail = () => {
      if (generation.current !== request) return;
      stop();
      toast.error('Voice sample could not be played');
    };
    audio.onended = () => { if (generation.current === request) stop(); };
    audio.onerror = fail;
    setPlayingId(voice.voice_id);
    try { await audio.play(); } catch { fail(); }
  }, [stop]);
  useEffect(() => stop, [stop]);
  return { playingId, play, stop };
};